// extracted by mini-css-extract-plugin
export default {"container":"XO-z","darkBackground":"YO-z","whiteBackground":"ZO-z","headerButton":"_O-z","calloutHeading":"aP-z","calloutSubHeading":"bP-z"};